import DestinationPage from "@/components/DestinationPage";

const related = [
  { name: "Turcia", slug: "turcia", image: "https://images.unsplash.com/photo-1774850691859-0e339f94bebb?w=600&q=80" },
  { name: "Grecia", slug: "grecia", image: "https://images.unsplash.com/photo-1506242592132-b7476b527d50?w=600&q=80" },
  { name: "Zanzibar", slug: "zanzibar", image: "https://images.unsplash.com/photo-1559934303-856aae38610f?w=600&q=80" },
];

export default function EgyptPage() {
  return (
    <DestinationPage
      name="Egipt" nameRo="Egipt" slug="egipt" flag="🇪🇬"
      heroImage="https://images.unsplash.com/photo-1705628080778-f86b2f90a114?w=1920&q=80"
      metaTitle="Vacanță în Egipt din Chișinău | Pachete Turistice Egipt – Premium Style Travel"
      metaDescription="Oferte vacanță Egipt din Chișinău. Pachete all inclusive Hurghada, Sharm el Sheikh. Zbor + hotel + transfer + asigurare inclus. Sună +373 60609292."
      tagline="Piramidele, Marea Roșie și misterele faraonilor te așteaptă. Pachete all inclusive din Chișinău."
      description="Egiptul este una dintre cele mai căutate destinații turistice din lume, combinând plajele paradisiace ale Mării Roșii cu moștenirea milenară a faraonilor. Hurghada și Sharm el-Sheikh oferă hoteluri de 4 și 5 stele cu servicii all inclusive de excepție, ape cristaline pentru snorkeling și diving, și o atmosferă de neuitat. Piramidele din Giza, Sfinxul și Muzeul Național din Cairo completează experiența cu o incursiune în cea mai veche civilizație a lumii."
      highlights={[
        "Piramidele din Giza și Sfinxul – una dintre cele 7 minuni ale lumii",
        "Hurghada – plaje cu nisip alb și mare cristalină",
        "Sharm el-Sheikh – paradisul diverului și snorkelingului",
        "Croazieră pe Nil – de la Luxor la Aswan",
        "Muzeul Național din Cairo – comori ale faraonilor",
        "Templele din Luxor și Karnak",
        "Bazarul Khan el-Khalili – suvenire și experiențe locale",
        "Hoteluri 5 stele All Inclusive pe malul Mării Roșii",
      ]}
      included={[
        "✈️ Zbor dus-întors din Chișinău",
        "🏨 Cazare hotel 4★ / 5★ All Inclusive",
        "🚌 Transfer aeroport – hotel – aeroport",
        "🛡️ Asigurare medicală de călătorie",
        "📋 Vize și taxe de aeroport incluse",
      ]}
      faqs={[
        { q: "Cât costă o vacanță în Egipt din Chișinău?", a: "Prețurile variază în funcție de hotel, perioadă și numărul de persoane. Contactați-ne la +373 60609292 pentru o ofertă personalizată." },
        { q: "Este nevoie de viză pentru Egipt?", a: "Da, cetățenii moldoveni au nevoie de viză pentru Egipt. Noi ne ocupăm de întregul proces de viză inclus în pachet." },
        { q: "Când este cel mai bun moment pentru vacanță în Egipt?", a: "Octombrie–Mai este perioada ideală, când temperaturile sunt moderate (20-28°C). Vara poate fi foarte călduroasă (40°C+)." },
        { q: "Ce include pachetul All Inclusive?", a: "Mesele principale (mic dejun, prânz, cină), băuturile locale, animație, acces la piscine și plajă." },
        { q: "Câte zile este recomandat pentru Egipt?", a: "Minimum 7 nopți pentru relaxare la mare. 10-14 nopți dacă doriți și excursii la Cairo și Luxor." },
      ]}
      relatedDestinations={related}
    />
  );
}
